import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'padStart',
  standalone: true,
})
export class PadStartPipe implements PipeTransform {
  transform(value: string | number, length = 3): string {
    if (typeof value === 'number') {
      value = value.toString();
    }

    return value.padStart(length, '0');
  }
}
